module.exports = __webpack_public_path__ + "static/media/header-typeface.c1cf670b.png";